module.exports = {
    list: ["String", "Date", "Enum", "URL"]
};
